<script setup lang="ts">
import { ref, watch, onErrorCaptured } from 'vue'
import { useRoute } from 'vue-router'

const error = ref<Error | null>(null)
const errorInfo = ref<string>('')

onErrorCaptured((err, _instance, info) => {
  error.value = err instanceof Error ? err : new Error(String(err))
  errorInfo.value = info
  console.error('[ErrorBoundary]', err, info)
  return false
})

const route = useRoute()
watch(() => route.fullPath, () => {
  if (error.value) reset()
})

const reset = () => {
  error.value = null
  errorInfo.value = ''
}
</script>

<template>
  <slot v-if="!error" />
  <div v-else class="error-boundary">
    <div class="error-boundary-content">
      <p class="error-boundary-title">Что-то пошло не так</p>
      <p class="error-boundary-message">{{ error?.message || 'Неизвестная ошибка' }}</p>
      <button class="error-boundary-btn" @click="reset">Попробовать снова</button>
    </div>
  </div>
</template>

<style scoped>
.error-boundary {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 200px;
  padding: 2rem;
}
.error-boundary-content {
  text-align: center;
  max-width: 400px;
}
.error-boundary-title {
  font-size: 1.125rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--color-text, #333);
}
.error-boundary-message {
  font-size: 0.875rem;
  color: var(--color-text-muted, #666);
  margin-bottom: 1rem;
  word-break: break-word;
}
.error-boundary-btn {
  padding: 0.5rem 1.25rem;
  border: none;
  border-radius: 6px;
  background: var(--color-primary, #4f46e5);
  color: #fff;
  font-size: 0.875rem;
  cursor: pointer;
}
.error-boundary-btn:hover {
  opacity: 0.9;
}
</style>
